import styled from 'styled-components';

import { Color, FontWeight, Breakpoint } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';
import { Image } from '../image/image.component';

import { AuctionDeadlineLabelProps } from './auctionBox.types';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const BackgroundImage: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const DetailsContainer: StyledComponent<'div'> = styled.div`
  color: ${Color.White};
  position: absolute;
  bottom: 20px;
  left: 20px;
  padding-right: 20px;
`;

export const AuctionDeadlineLabel: StyledComponent<'div', AuctionDeadlineLabelProps> = styled.div<AuctionDeadlineLabelProps>`
  padding: 8px 12px;
  background-color: ${({ $isAuctionEnded }: AuctionDeadlineLabelProps): string => $isAuctionEnded 
    ? hexToRgba(Color.Black, 0.25) 
    : Color.Error500};
  color: ${Color.Gray100};
  border-radius: 4px;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 20px;
  left: 20px;
`;

export const Title: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;

  @media ${Breakpoint.Tablet} {
    font-size: 18px;
    line-height: 26px;
  }
`;

export const Deadline: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Light};
  font-size: 18px;
  line-height: 26px;

  @media ${Breakpoint.Tablet} {
    font-size: 16px;
    line-height: 22px;
  }
`;
